import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface MemberInterface {
  user: any | null;
  isLogin: boolean;
}

interface MemberAction {
  setLoginUser: (userData: any | null) => void;
  refreshLoginUser: () => void;
}

const useUserStore = create<MemberInterface & MemberAction>()(
  devtools(
    immer((set) => ({
      user: null,
      isLogin: false,
      setLoginUser: (userData: any | null) => {
        set((state) => {
          state.user = userData;
          state.isLogin = userData != null;
        });
      },
      refreshLoginUser: () => {
        set((state) => {
          state.user = null;
          state.isLogin = false;
        });
      },
    })),
    {
      name: 'userStore',
    },
  ),
);

export default useUserStore;
